import React, { useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const DeepLearning = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: ¿Por qué Deep Learning? (Más allá del ML Clásico)",
      url: `${videoBaseURL}DL1.mp4`,
      conceptoclave: [
        'La diferencia entre ML Clásico y Deep Learning.',
      ],
      termino: [
        'Analogía (Ingeniería): El problema de la "Ingeniería de Características" (Feature Engineering) manual vs. la automática.'
      ]
    },
    {
      nombre: 'Video 2: ¿Qué es una Red Neuronal? El "Cerebro" de la IAA',
      url: `${videoBaseURL}DL2.mp4`,
      conceptoclave: [
        'El bloque de construcción: la neurona (perceptrón) y las capas.',
      ],
      termino: [
        'Analogía (Ingeniería): Una red neuronal como una cadena de procesamiento de señales (DSP) autoajustable.'
      ]
    },
    {
      nombre: 'Video 3: Redes Recurrentes (RNN/LSTM): La IA que entiende Secuencias',
      url: `${videoBaseURL}DL3.mp4`,
      conceptoclave: [
        'Modelos con "memoria" para analizar datos secuenciales.',
      ],
      termino: [
        'Aplicación (Observabilidad): Análisis de logs de series temporales y predicción de fallos.'
      ]
    },
    {
      nombre: "Video 4: Transformers y LLMs: La IA que entiende el Contexto",
      url: `${videoBaseURL}DL4.mp4`,
      conceptoclave: [
        'El mecanismo de "Atención" y los Modelos de Lenguaje Grandes (LLMs).',
      ],
      termino: [
        'Aplicación (Observabilidad): Resumir 10,000 logs en un solo párrafo (IA Generativa para AIOps).'
      ]
    },
    {
      nombre: "Video 5: Detección de Anomalías con Autoencoders",
      url: `${videoBaseURL}DL5.mp4`,
      conceptoclave: [
        'La arquitectura "compresor/descompresor" para aprender qué es "normal".',
      ],
      termino: [
        'Aplicación (Ciberseguridad): Detección de intrusos (NDR) y comportamiento anómalo de usuarios (UEBA).'
      ]
    },
    {
      nombre: "Video 6: Caso Práctico (AIOps): De 500 Alertas a 1 Causa Raíz",
      url: `${videoBaseURL}DL6.mp4`,
      conceptoclave: [
        'Unir un LLM (para logs) y un Autoencoder (para métricas) para resolver un incidente de "aplicación lenta".',
      ],
      termino: [
        'Caso práctico que unifica las aplicaciones de los videos anteriores para demostrar cómo AIOps utiliza múltiples modelos de Deep Learning en conjunto para resolver un problema real'
      ]
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="text-center">
          <h1 className="mt-4">Deep Learning para Ingenieros de ITOps</h1>
          <hr className="linea-horizontal" />
        </div>

        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título del Video</th>
                <th>Concepto Clave</th>
                <th>Analogía/Aplicación</th>
                <th>Reproducir</th>
              </tr>
            </thead>

            <tbody>
              {videos.map((video, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td><b>{video.nombre}</b></td>
                  <td>
                      <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                        {video.conceptoclave.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                  </td>
                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.termino.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    <Button
                      className="boton"
                      variant="primary"
                      onClick={() => handleShow(video.url)}
                    >
                      Reproducir Video
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reproducción de Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default DeepLearning;
